
































import { Opportunity, OpportunityMembershipStatus } from '@/models/opportunities';
import { Actions } from '@/store';
import { ToastsService } from '@/utils';
import Vue from 'vue';

export default Vue.extend({
  name: 'ConfirmLaunchModal',
  props: {
    opportunity: Object as () => Opportunity,
  },
  data() {
    return {
      loader: {
        isRequestPending: false,
      },
    };
  },
  computed: {
    numberOfAcceptedMembers(): number {
      return this.opportunity.members.filter((e) => e.membershipStatus === OpportunityMembershipStatus.Accepted).length;
    },
    numberOfMembersTranslation(): string {
      return this.numberOfAcceptedMembers > 1
        ? this.$t('opportunities.confirm-launch-modal.member.plural',
          { number: this.numberOfAcceptedMembers }) as string
        : this.$t('opportunities.confirm-launch-modal.member.singular') as string;
    },
    numberOfVacanciesTranslation(): string {
      return this.opportunity.vacancies > 1
        ? this.$t('opportunities.confirm-launch-modal.vacancy.plural',
          { number: this.opportunity.vacancies }) as string
        : this.$t('opportunities.confirm-launch-modal.vacancy.singular') as string;
    },
    confirmationContent(): string {
      if (this.numberOfAcceptedMembers > this.opportunity.vacancies) {
        return this.$t(
          'opportunities.confirm-launch-modal.content.higher',
          {
            membersNumber: this.numberOfMembersTranslation,
            vacanciesNumber: this.numberOfVacanciesTranslation,
          },
        ) as string;
      } else if (this.numberOfAcceptedMembers < this.opportunity.vacancies) {
        return this.$t(
        'opportunities.confirm-launch-modal.content.lower',
          {
            membersNumber: this.numberOfMembersTranslation,
            vacanciesNumber: this.numberOfVacanciesTranslation,
          },
        ) as string;
      }

      return this.$t('opportunities.confirm-launch-modal.content.basic') as string;
    },
  },
  methods: {
    async launchOpportunity() {
      this.loader.isRequestPending = true;
      try {
        await this.$store.dispatch(Actions.opportunities.launchOpportunity, this.opportunity.id);
        this.$bvModal.hide('confirm-launch-opportunity-modal');
        ToastsService.success(this.$t('opportunities.details.notifications.launch') as string);
        this.$emit('refresh');
      } finally {
        this.loader.isRequestPending = false;
      }
    },
  },
});
